module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0010.jpg?v=c19ba78b";